import { Card, Col, Row } from "antd";
import { NegativeIcon, NeutralIcon, PositiveIcon, ReviewIcon } from "../icon";

const Reviews = ({ reviewTypeData }) => {
  return (
      <Card bordered={false} className="filter-box marketpulse-subheader-card">
        <Row gutter={[16, 16]} justify={"space-around"} className="">
          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <div className="reviews-box">
              <ReviewIcon className="review-type-icon" />
              <div>
                <div className="label">Reviews</div>
                <div className="review-count">
                  {reviewTypeData?.total_reviews || 0}
                </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
          <div className="likes-box-base likes-box">
            <PositiveIcon className="review-type-icon" />
            <div>
              <div className="label">Positive</div>
              <div className="review-count">{reviewTypeData?.positive_count || 0}</div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
          <div className="dislikes-box-base dislikes-box">
            <NegativeIcon className="review-type-icon" />
            <div>
              <div className="label">Negative</div>
              <div className="review-count">{reviewTypeData?.negative_count || 0}</div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
          <div className="neutral-box-base neutral-box">
            <NeutralIcon className="review-type-icon" />
            <div>
              <div className="label">Neutral</div>
              <div className="review-count">{reviewTypeData?.neutral_count || 0}</div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default Reviews;
